var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsObject, IsUUID } from 'class-validator';
import { UserProfileDto } from '../../user/index.js';
import { PreventionCourseModuleFullSizeDto } from './prevention-course-module.full-size.dto.js';
export class PreventionModuleTrackingFullSizeDto {
    id;
    createdAt;
    updatedAt;
    preventionCourseModuleId;
    preventionCourseModule;
    user;
    userId;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PreventionModuleTrackingFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PreventionModuleTrackingFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PreventionModuleTrackingFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PreventionModuleTrackingFullSizeDto.prototype, "preventionCourseModuleId", void 0);
__decorate([
    IsObject(),
    Expose(),
    Type(() => PreventionCourseModuleFullSizeDto),
    __metadata("design:type", PreventionCourseModuleFullSizeDto)
], PreventionModuleTrackingFullSizeDto.prototype, "preventionCourseModule", void 0);
__decorate([
    IsObject(),
    Exclude(),
    Type(() => UserProfileDto),
    __metadata("design:type", Function)
], PreventionModuleTrackingFullSizeDto.prototype, "user", void 0);
__decorate([
    IsUUID(),
    Exclude(),
    __metadata("design:type", String)
], PreventionModuleTrackingFullSizeDto.prototype, "userId", void 0);
//# sourceMappingURL=prevention-module-tracking.full-size.dto.js.map